//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 import {mapActions} from 'vuex';
  export default {
    components:{

    },
    data(){
      return {
        canSubmit:false,
        isCooldown:false,
        cdTime:10,
        step:1,
        tmpSex:0,
        sex:0,
        age:null,
        selectSex:false,
        form:{
          phone:'',
          code:''
        }
      }
    },
    computed:{
      agenum:{
        get:function () {
          return this.age;
        },
        set:function (v) {
          let visiableAge=v.replace(/[^\d]/g,'');
          if(visiableAge<0){
            this.age=0;
          }else if(visiableAge>100){
            this.age=100
          }else{
            this.age=visiableAge;
          }

        }
      }
    },
    methods:{
      ...mapActions(['changeTestLevel']),
      sexChoose(e){
        console.log(e);
        if(e.target){
          this.tmpSex=e.target.dataset.sex;
        }
      },
      sendEms(){
        if(this.form.phone&&this.form.phone!=''){
          if(!(/^1[3456789]\d{9}$/.test(this.form.phone))){
            alert("手机号码有误");
            return false;
          }
        }else{
          alert('请输入手机号码');
          return false;
        }
        this.axios.post('xcx/User/sendcode',{phone:this.form.phone,type:1,user_key:this.$store.state.tempat}).then((res)=>{
          this.isCooldown=true;
          var timer=setInterval(()=>{
            this.cdTime--;
            if(this.cdTime<=0){
              this.isCooldown=false;
              this.cdTime=60
              clearInterval(timer);
            }
          },1000)
        })
      },
      reg(){
        this.axios.post('xcx/login/mobilelogin',{...this.form,user_key:this.$store.state.tempat}).then(res=>{
          this.step=2;
            this.$store.dispatch('changeUserInfo',{phone:this.form.phone});
            localStorage.setItem('token',this.$store.state.user_key);
            if(this.$route.query.skiptest=='true'){
              this.axios.post('/xcx/Order/testRecommend',{test_result:1,type:1}).then(res=>{
              })
            }
        })
      },
      completeInfo(){
        if(this.age!=null&&this.age!=''){
          this.axios.post('/xcx/Login/perfect',{
            sex:this.sex,
            age:this.age
          }).then(res=>{
            var level=0;
            if(this.age>=2&&this.age<3){
              level=0;
            }else if(this.age>=3&&this.age<4){
              level=1;
            }else if(this.age>=4&&this.age<5){
              level=2;
            }else if(this.age>=5&&this.age<6){
              level=3;
            }else if(this.age>=6&&this.age<7){
              level=4;
            }else if(this.age>=7&&this.age<8){
              level=5;
            }else if(this.age>=8&&this.age<9){
              level=6;
            }else{
              level=7;
            }
            this.changeTestLevel(level);
            if(this.$route.query.skiptest=='true'){
              this.$router.replace({name:'tutorial',params:{showalert:true}});
            }else{
              //this.$router.push({name:'evaluation'});
              this.$router.replace({name:'tutorial'});
            }
            
          })
        }

      }
    },
    watch:{
      'form':{
        handler:function(n,o){
          // console.log(n,o);
          if(!(/^1[3456789]\d{9}$/.test(n.phone))||n.code==''){
            this.canSubmit=false;
          }else{
            this.canSubmit=true;
          }
        },
        deep:true
      },
    }

}



// WEBPACK FOOTER //
// ./src/components/register/register.vue